"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonDataFilter = void 0;
const React = require("react");
const constants_1 = require("../../utils/constants");
const form_utils_1 = require("../../utils/form.utils");
const BronsonDataFilter = (props) => {
    const handleKeyDown = (bronsonEvent) => {
        if (bronsonEvent.event.key === 'Enter') {
            props.onSearchInput(bronsonEvent.value);
            props.onFilter();
        }
    };
    const [currentFilter, setCurrentFilter] = React.useState(props.fields.filter((field) => field.id === props.filtersDefaultValue)[0]);
    return (React.createElement("div", { className: 'o-layout u-mb' },
        React.createElement("div", { className: 'o-layout__item u-1/3 u-1/1@s' },
            React.createElement("label", null,
                React.createElement("h6", { className: 'u-mb-none' }, "Seleccionar campo")),
            React.createElement(form_utils_1.WrapperBronsonFormSelect, { defaultValue: props.filtersDefaultValue || '', onChange: (event) => {
                    props.onFieldChange(event.value);
                    const filter = props.fields.filter((field) => field.id === event.value)[0];
                    setCurrentFilter(filter);
                }, elementId: 'filter-field' },
                React.createElement("option", { value: '' }, "Selecciona un campo para realizar una b\u00FAsqueda"),
                props.fields.map((field, key) => (React.createElement("option", { id: `filter-field-${field.id}`, key: key, value: field.id }, field.title))))),
        React.createElement("div", { className: 'o-layout__item u-2/3 u-1/1@s' },
            React.createElement(form_utils_1.WrapperBronsonFormInput, { label: React.createElement("h6", { className: 'u-mb-none' }, "B\u00FAsqueda"), defaultValue: props.searchDefaultValue ? props.searchDefaultValue : '', onChange: (event) => {
                    props.onSearchInput(event.value);
                }, onKeyDown: handleKeyDown, elementId: 'filter-search', placeholder: 'Buscar en este campo', maxLength: props.searchMaxLength || -constants_1.one, validations: currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.validations },
                React.createElement("button", { id: 'filter-apply', className: 'c-input__addon', onClick: () => {
                        props.onFilter();
                    } },
                    React.createElement("i", { className: 'c-icon c-icon--[semantic-search]' }))))));
};
exports.BronsonDataFilter = BronsonDataFilter;
